module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/free-time-mobile-findx2.afff9d42.png";